<div class="text-center force-mobile-login">

    <div class="right-section">
        <mat-card>
            <mat-card-content>
                <h3 class="welcome-text">
                    {{ 'LOGIN.WELCOME' | transloco }}
                </h3>
                <p class="description">
                    {{ 'LOGIN.POPUP_LOGIN' | transloco }}
                </p>

                <div class="buttons flex flex-col items-center">
                    <button mat-raised-button type="submit" (click)="login()"
                        class="btn-primary-full">
                        {{ ('LOGIN.SIGN_UP_SIGN_IN' | transloco) | uppercase }}
                    </button>
                    <button mat-raised-button color="primary" type="submit" (click)="continueAsGuest()"
                        class="btn-secondary-full">
                        {{ ('LOGIN.GUEST' | transloco) | uppercase }}
                    </button>

                    <button class="hidden md:block mt-2" (click)="toggleLanguage()">
                        <img src="{{languageImageSource}}" alt="toggle language" class="w-[25px] h-[25px]">
                    </button>

                </div>
            </mat-card-content>
        </mat-card>
    </div>

</div>